import http from '../../../Utils/http';
import { toast } from 'react-toastify';

const deleteDsoUser = {
  name: 'deleteDsoUser',
  state: {
    loading: false,
    error: '',
  },
  reducers: {
    deleteRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    deleteSucceeded(state) {
      return {
        ...state,
        loading: false,
        error: '',
      };
    },

    deleteFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async removeDsoUser(id) {
      try {
        this.deleteRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/organization/deleteUser/${id}?user_id=${userInfo.id}&org_id=${orgId}`;
        const response = await http.delete(url);

        if (response?.data?.success) {
          const usersData = await http.get(`savvy/users/countUsers/${orgId}`);

          if (userInfo?.organization?.type === 'ADV' && usersData?.data?.data?.count === 1 && !usersData?.data?.data?.rows?.[0]?.isUserSkipped)
            dispatch.ProgressStepAdv.DeleteADVProgressStep(3);
          if (userInfo?.organization?.type === 'DSO' && usersData?.data?.data?.count === 1 && !usersData?.data?.data?.rows?.[0]?.isUserSkipped)
            dispatch.ProgressStepDSO.DeleteDSOProgressStep(6);

          this.deleteSucceeded();

          const successMessage = response?.data?.message || 'User deleted successfully!';
          toast.success(successMessage);
        } else {
          const errorMessage = response?.data?.message || response?.data?.error || 'Failed to delete user';
          this.deleteFailed(errorMessage);
          toast.error(errorMessage);
        }
      } catch (err) {
        const errorMessage = err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'An error occurred while deleting user';

        this.deleteFailed(errorMessage);
        toast.error(errorMessage);
      }
    },
  }),
};

export default deleteDsoUser;
